/**
 * The pool's password policy, as a person needs to hear it before they pick one.
 *
 * The pool requires at least 8 characters, a lowercase letter and a number (describe-user-pool,
 * PasswordPolicy). The builder said nothing at all, and the published sites' sign-up page said
 * only "At least 8 characters" — so a password it called fine was refused with a message about
 * length. One sentence, the whole rule, wherever a password is chosen.
 */
export const PASSWORD_RULE = 'At least 8 characters, with a lowercase letter and a number';
